// DO NOT MODIFY! THIS FILE IS AUTOGENERATED BY generate-endpoint-spec.util.ts

import { RequestHandler } from 'express';

export const TSpecRoute_publishAnnouncement = () => "/announcements";

export type TSpecHandler_publishAnnouncement = RequestHandler<TSpecPathPublishAnnouncement, any, TSpecBodyPublishAnnouncement, TSpecQueryPublishAnnouncement, {}>;

export interface TSpecPathPublishAnnouncement {  }

export interface TSpecBodyPublishAnnouncement {
  announcementType: EAnnouncementType;
  title: string;
  body?: string;
  surveyJson?: string;
  recipients: {
    id: string;
  }[];
  isCritical: boolean;
  isAnonymous?: boolean;
  attachments: string[];
}

export enum EAnnouncementType {
  ANNOUNCEMENT = "ANNOUNCEMENT",
  SURVEY = "SURVEY"
}

export interface TSpecQueryPublishAnnouncement {
  AppVersion?: string;
  AppUser?: string;
}
